import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import {
  ArrayHelpers,
  Field,
  FieldArray,
  FormikErrors,
  FormikProps,
} from "formik";
import IsRequired from "../../form/IsRequired";
import { TableNumbers } from "../../layouts/TableNumbers";
import { KlientkontoerklaeringTexts } from "../texts";
import { FormRow, FormRowInput, FormRowLabel } from "../../layouts/FormRow";
import ValidatedField from "../../form/ValidatedField";
import { KlientkontoerklaeringFormValues } from "../../../interfaces/klientkontoerklaering";
import ValidationError from "../../form/ValidationError";
import IconDelete from "../../icons/IconDelete";
import { FormText } from "../../form/FormText";
import { FormRadio } from "../../form/FormRadio";
import { samleklientbankkontiOnPaste } from "../../../util/klientkontoerklaering";
import { FormSelect } from "../../form/FormSelect";

const AESection1 = ({
  texts,
  formikProps,
  locked,
}: {
  texts: KlientkontoerklaeringTexts;
  formikProps: FormikProps<KlientkontoerklaeringFormValues>;
  locked?: boolean;
}) => {
  const { values, errors, touched, initialValues } = formikProps;

  return (
    <AccordionItem value="Sektion1">
      <AccordionHeader>
        <span>1.</span> <span>{texts.advokatens_section_1.title}</span>
      </AccordionHeader>
      <AccordionBody>
        <fieldset className="vstack" disabled={locked}>
          <div className="mb-3">
            <h5 className="mb-3 fw-normal">
              1.1{" "}
              {
                texts.advokatens_section_1
                  .advokatens_section_1_1_samleklientbankkonti.title
              }
            </h5>
            <FieldArray
              name={
                texts.advokatens_section_1
                  .advokatens_section_1_1_samleklientbankkonti.id
              }
              render={(arrayHelpers: ArrayHelpers) => (
                <table className="table table-borderless table-sm table--fixed">
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: 35 }}></th>
                      <th scope="col">
                        Pengeinstitut
                        <IsRequired />
                      </th>
                      <th scope="col">
                        Reg.- og kontonr.
                        <IsRequired />
                      </th>
                      <th scope="col">Dato for oprettelse</th>
                      <th scope="col">CVR for konto</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values.advokatens_section_1_1_samleklientbankkonti.map(
                      (_samleklientbankkonto, i) => {
                        const errors2 =
                          errors.advokatens_section_1_1_samleklientbankkonti
                            ? (errors
                                .advokatens_section_1_1_samleklientbankkonti[
                                i
                              ] as FormikErrors<
                                KlientkontoerklaeringFormValues["advokatens_section_1_1_samleklientbankkonti"][number]
                              >)
                            : undefined;
                        const touched2 =
                          touched.advokatens_section_1_1_samleklientbankkonti &&
                          touched.advokatens_section_1_1_samleklientbankkonti[
                            i
                          ];
                        return (
                          <tr key={i}>
                            <th scope="row" className="px-0">
                              <TableNumbers>{(i + 1).toString()}</TableNumbers>
                            </th>
                            <td>
                              <div className="position-relative">
                                <Field
                                  name={`advokatens_section_1_1_samleklientbankkonti[${i}].pengeinstitution`}
                                  placeholder="Pengeinstitut"
                                  className={`form-control ${
                                    touched2?.pengeinstitution &&
                                    errors2?.pengeinstitution
                                      ? " is-invalid"
                                      : null
                                  }`}
                                  autoComplete="off"
                                  onPaste={(e) => {
                                    samleklientbankkontiOnPaste(
                                      e,
                                      values,
                                      arrayHelpers,
                                      i,
                                    );
                                  }}
                                />
                                <ValidationError
                                  error={errors2?.pengeinstitution}
                                  show={touched2?.pengeinstitution}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="position-relative">
                                <Field
                                  name={`advokatens_section_1_1_samleklientbankkonti[${i}].regKontoNr`}
                                  placeholder="Reg.- og kontonr."
                                  className={`form-control ${
                                    touched2?.regKontoNr && errors2?.regKontoNr
                                      ? " is-invalid"
                                      : null
                                  }`}
                                  autoComplete="off"
                                />
                                <ValidationError
                                  error={errors2?.regKontoNr}
                                  show={touched2?.regKontoNr}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="position-relative">
                                <FormSelect
                                  formik={formikProps}
                                  name={`advokatens_section_1_1_samleklientbankkonti[${i}].opretDato`}
                                  className="form-control"
                                  // @ts-ignore
                                  options={
                                    advokatens_section_1_1_samleklientbankkonti_Options
                                  }
                                  defaultValue={get_advokatens_section_1_1_samleklientbankkonti_InitialValue(
                                    initialValues
                                      .advokatens_section_1_1_samleklientbankkonti?.[
                                      i
                                    ]?.opretDato,
                                  )}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="position-relative">
                                <Field
                                  name={`advokatens_section_1_1_samleklientbankkonti[${i}].cvrKonto`}
                                  className={`form-control ${
                                    touched2?.cvrKonto && errors2?.cvrKonto
                                      ? " is-invalid"
                                      : null
                                  }`}
                                  placeholder="CVR for konto"
                                  autoComplete="off"
                                />
                                <ValidationError
                                  error={errors2?.cvrKonto}
                                  show={touched2?.cvrKonto}
                                />
                              </div>
                            </td>
                            <td className="px-0">
                              <button
                                className="btn btn-circle"
                                type="button"
                                aria-label="Fjern række"
                                title="Fjern række"
                                onClick={() => {
                                  arrayHelpers.remove(i);
                                }}
                              >
                                <IconDelete />
                              </button>
                            </td>
                          </tr>
                        );
                      },
                    )}
                    <tr>
                      <th></th>
                      <td colSpan={4}>
                        <button
                          className="btn btn-light w-100"
                          style={{ marginTop: 6 }}
                          type="button"
                          onClick={() => {
                            arrayHelpers.push({
                              pengeinstitution: "",
                              regKontoNr: "",
                            });
                          }}
                        >
                          Tilføj flere
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            />
          </div>
          <FormRow>
            <FormRowLabel
              section="1.2"
              htmlFor={
                texts.advokatens_section_1
                  .advokatens_section_1_2_bogføringssystem.id
              }
            >
              {
                texts.advokatens_section_1
                  .advokatens_section_1_2_bogføringssystem.title
              }
              <IsRequired />
            </FormRowLabel>
            <FormRowInput>
              <ValidatedField
                error={errors.advokatens_section_1_2_bogføringssystem}
                touched={touched.advokatens_section_1_2_bogføringssystem}
                name={
                  texts.advokatens_section_1
                    .advokatens_section_1_2_bogføringssystem.id
                }
                id={
                  texts.advokatens_section_1
                    .advokatens_section_1_2_bogføringssystem.id
                }
                placeholder="Bogføringssystem"
                wrapper
              />
            </FormRowInput>
          </FormRow>
          <FormRow>
            <FormRowLabel
              section="1.3"
              htmlFor={
                texts.advokatens_section_1.advokatens_section_1_3_aabningsdag.id
              }
            >
              {
                texts.advokatens_section_1.advokatens_section_1_3_aabningsdag
                  .title
              }
              <IsRequired />
            </FormRowLabel>
            <FormRowInput>
              <FormText
                type="date"
                id={
                  texts.advokatens_section_1.advokatens_section_1_3_aabningsdag
                    .id
                }
                formik={formikProps}
              />
            </FormRowInput>
          </FormRow>
          <FormRow>
            <FormRowLabel
              radioHeading
              className="align-items-center"
              column="col-9"
              section="1.4"
            >
              {
                texts.advokatens_section_1
                  .advokatens_section_1_4_dispensation_ja_nej.title
              }
              <IsRequired />
            </FormRowLabel>
            <FormRowInput className="d-flex flex-column gap-1" column="col-3">
              <div className="d-flex align-items-center gap-1 justify-content-end position-relative">
                <FormRadio
                  name={
                    texts.advokatens_section_1
                      .advokatens_section_1_4_dispensation_ja_nej.id
                  }
                  value="Ja"
                  invalid={
                    errors?.[
                      texts.advokatens_section_1
                        .advokatens_section_1_4_dispensation_ja_nej.id
                    ] &&
                    touched?.[
                      texts.advokatens_section_1
                        .advokatens_section_1_4_dispensation_ja_nej.id
                    ]
                  }
                >
                  Ja
                </FormRadio>
                <FormRadio
                  name={
                    texts.advokatens_section_1
                      .advokatens_section_1_4_dispensation_ja_nej.id
                  }
                  value="Nej"
                  invalid={
                    errors?.[
                      texts.advokatens_section_1
                        .advokatens_section_1_4_dispensation_ja_nej.id
                    ] &&
                    touched?.[
                      texts.advokatens_section_1
                        .advokatens_section_1_4_dispensation_ja_nej.id
                    ]
                  }
                >
                  Nej
                </FormRadio>
                <ValidationError
                  error={
                    errors?.[
                      texts.advokatens_section_1
                        .advokatens_section_1_4_dispensation_ja_nej.id
                    ]
                  }
                  show={
                    touched?.[
                      texts.advokatens_section_1
                        .advokatens_section_1_4_dispensation_ja_nej.id
                    ]
                  }
                />
              </div>
            </FormRowInput>
          </FormRow>
          {values.advokatens_section_1_4_dispensation_ja_nej === "Ja" && (
            <>
              <FormRow className="gap-3 d-flex">
                <h5 className="fw-normal flex-shrink-0 lh-base">1.5</h5>
                <div className="flex-fill">
                  <label
                    className="form-label"
                    htmlFor={
                      texts.advokatens_section_1
                        .advokatens_section_1_5_dispensationDato.id
                    }
                  >
                    {
                      texts.advokatens_section_1
                        .advokatens_section_1_5_dispensationDato.label
                    }
                    <IsRequired />
                  </label>
                  <FormText
                    formik={formikProps}
                    type="date"
                    id={
                      texts.advokatens_section_1
                        .advokatens_section_1_5_dispensationDato.id
                    }
                  />
                </div>
                <div className="flex-fill">
                  <label
                    className="form-label"
                    htmlFor={
                      texts.advokatens_section_1
                        .advokatens_section_1_5_dispensationSagsnr.id
                    }
                  >
                    {
                      texts.advokatens_section_1
                        .advokatens_section_1_5_dispensationSagsnr.label
                    }
                    <IsRequired />
                  </label>
                  <FormText
                    formik={formikProps}
                    id={
                      texts.advokatens_section_1
                        .advokatens_section_1_5_dispensationSagsnr.id
                    }
                    placeholder="Sagsnummer"
                  />
                </div>
                <div>
                  <label
                    className="form-label"
                    htmlFor={
                      texts.advokatens_section_1
                        .advokatens_section_1_5_disp_periode.fraId
                    }
                  >
                    {
                      texts.advokatens_section_1
                        .advokatens_section_1_5_disp_periode.label
                    }
                    <IsRequired />
                  </label>
                  <div className="form-control form-control--group">
                    <FormText
                      formik={formikProps}
                      type="date"
                      id={
                        texts.advokatens_section_1
                          .advokatens_section_1_5_disp_periode.fraId
                      }
                      className="border-0"
                    />
                    -
                    <FormText
                      formik={formikProps}
                      type="date"
                      id={
                        texts.advokatens_section_1
                          .advokatens_section_1_5_disp_periode.tilId
                      }
                      className="border-0"
                    />
                  </div>
                </div>
              </FormRow>
              <FormRow>
                <FormRowLabel
                  section="1.6"
                  htmlFor={
                    texts.advokatens_section_1
                      .advokatens_section_1_6_bogføringAntalDage.id
                  }
                >
                  {
                    texts.advokatens_section_1
                      .advokatens_section_1_6_bogføringAntalDage.title
                  }
                  <IsRequired />
                </FormRowLabel>
                <FormRowInput>
                  <FormText
                    formik={formikProps}
                    id={
                      texts.advokatens_section_1
                        .advokatens_section_1_6_bogføringAntalDage.id
                    }
                    placeholder="0"
                  />
                </FormRowInput>
              </FormRow>
            </>
          )}
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
};

const advokatens_section_1_1_samleklientbankkonti_Options = [
  { value: null, label: "Vælg..." },
  { value: "Før 1. marts 2020", label: "Før 1. marts 2020" },
  { value: "Efter 1. marts 2020", label: "Efter 1. marts 2020" },
];

function get_advokatens_section_1_1_samleklientbankkonti_InitialValue(
  initialValue: string | undefined,
) {
  return advokatens_section_1_1_samleklientbankkonti_Options
    .map((option) => option.value)
    .indexOf(initialValue ?? "") > -1
    ? initialValue
    : undefined;
}

export default AESection1;
